import * as React from 'react';
import { connect } from 'react-redux';
import { editSeller, fetchSeller } from '../../actions/sellersActions';
import { fetchUsuarios } from '../../actions/usuariosActions';

class MailUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            usuarioError: true
        }
    };

    confirmarPassword = (e) => {
        let confirmPassword = e.target.value;
        if (confirmPassword != this.props.seller.password) {
            this.setState({ usuarioError: true });
        } else {
            this.setState({ usuarioError: false });
            this.myChangeHandler(e)
        }
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    componentWillReceiveProps = prevProps => {
        if (this.didEdit) {
            this.props.fetchSeller(this.props.id);
            this.setState({ didEdit: false });
        }
    }

    render() {

        return (
            <form className="form-horizontal form-material   p-10" onSubmit={this.onSubmit}>
                <div className="tab-content">
                    <div className="tab-pane p-20 active " name="datos" id="home2" role="tabpanel">
                        <div className="row">

                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label>Email Usuario</label>
                                    <input type="text" className="form-control" value={this.props.seller.emailUsuario} onChange={this.myChangeHandler} placeholder="usuario@dominio.com" name="emailUsuario" />
                                </div>
                            </div>

                        </div>
                        <div className="row">

                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label>Usuario</label>
                                    <input type="text" className="form-control" value={this.props.seller.nombreUsuario} onChange={this.myChangeHandler} placeholder="Nombre Usuario" name="nombreUsuario" />
                                </div>
                            </div>

                        </div>

                        <div className="row">

                            <div hidden={this.props.seller.codigo} className="col-sm-12 col-md-6 col-lg-6">

                                <div className="form-group">
                                    <label>Contraseña</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={this.props.seller.password}
                                        onChange={this.myChangeHandler}
                                        placeholder=""
                                        name="password"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Confirmar contraseña</label>
                                    <input
                                        type="password"
                                        className={this.state.usuarioError ? "warning-input form-control" : "form-control"}
                                        value={this.props.seller.confirmarPassword}
                                        onChange={this.confirmarPassword}
                                        placeholder=""
                                        name="confirmarPassword"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => ({
    seller: JSON.stringify(state.general.generalObject) != "{}" ? state.general.generalObject : state.sellers.seller,
    tipoUsuario: state.general.tipoUsuario,
    usuario: JSON.stringify(state.usuarios.user) != "{}" ? state.usuarios.user : state.usuarios.usuario,
    idSeller: state.general.idSeller,
});

export default connect(mapStateToProps, { editSeller, fetchSeller, fetchUsuarios })(MailUsuario);